import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=fd6e3b6e&scoped=true"
import script from "./withdrawal.vue?vue&type=script&lang=js"
export * from "./withdrawal.vue?vue&type=script&lang=js"
import style0 from "./withdrawal.vue?vue&type=style&index=0&id=fd6e3b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6e3b6e",
  null
  
)

export default component.exports